<div class="okr-avatar-container" *ngFor="let assignee of visibleAssignees; let i = index">
  <ui-assignee-avatar
    class="okr-ui-group-assignee"
    [style.cursor]="isUserOwner ? 'pointer' : 'default'"
    [uiAlt]="assignee.name"
    [uiAssignee]="assignee"
    [uiSize]="size"
    [uiTooltipTitle]="getReviewerStatusForLocalization(assignee.id, 'visible') | localize : { user: assignee.name }"
    [uiTooltipPlacement]="assigneeTooltipPlacement"
    [uiShowTooltip]="true"
    (click)="openEditReviewers.emit()"></ui-assignee-avatar>
  <div class="okr-status-icon-workflow" [ngSwitch]="getReviewerStatus(assignee.id)">
    <i *ngSwitchCase="'approves'" [ngClass]="'approved'" ui-icon uiType="check"></i>
    <i *ngSwitchCase="'declines'" [ngClass]="'declined'" ui-icon uiType="pause"></i>
    <i *ngSwitchCase="'pending'" [ngClass]="'pending'" ui-icon uiType="clock"></i>
  </div>
</div>

<i
  class="okr-fake-reviewer-icon"
  *ngIf="fake.reviewers.length > 0"
  [style.cursor]="isUserOwner ? 'pointer' : 'default'"
  [uiTooltipTitle]="isUserOwner ? ('select_reviewers' | localize) : ('unassigned_cap' | localize)"
  (click)="openEditReviewers.emit()"
  ui-icon
  ui-tooltip
  uiTooltipPlacement="bottom"
  uiType="user">
</i>

<div class="okr-hidden-assignees">
  <ui-avatar
    class="okr-ui-group-assignee"
    *ngIf="hiddenAssignees.length > 0"
    [uiText]="'+' + hiddenAssignees.length"
    [style.z-index]="visibleAssignees.length"
    [uiTooltipTitle]="avatarGroupTooltipTemplate"
    uiSize="xs"
    ui-tooltip
    uiTooltipPlacement="bottom">
  </ui-avatar>
</div>

<ng-template #avatarGroupTooltipTemplate>
  <div class="okr-ui-assignee-avatar-group-tooltip-wrapper">
    <ui-assignee
      class="okr-workflow-assignee-icon"
      *ngFor="let assignee of hiddenAssignees"
      [uiAssignee]="assignee"
      [uiNameEllipsis]="true"
      [uiNameMultiline]="true"
      [uiNameSuffix]="getReviewerStatusForLocalization(assignee.id, 'hidden') | localize"
      (click)="openEditReviewers.emit()"
      uiSize="xs"></ui-assignee>
  </div>
</ng-template>
